export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-white py-20">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/7e959f42-2dc6-41f5-b1a3-5ba42a363ea3.png" 
                alt="BUBA d.o.o. Logo" 
                className="h-12 w-12 object-contain"
              />
              <h3 className="text-4xl font-extrabold">BUBA d.o.o.</h3>
            </div>
            <p className="text-base text-white/70 leading-relaxed max-w-md mb-8">
              A team of experts developing modern applications for the iOS platform, designed to enhance user experience and improve the security of mobile devices.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="w-10 h-10 border border-white/30 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-white/30 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-white/30 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-github-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-white/30 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-medium-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-white/70 mb-4">ADDRESS</h4>
            <p className="text-base text-white/85 leading-relaxed mb-8">
              Obala Pape Ivana Pavla II. 74<br />
              Dubrovnik, 20000<br />
              Croatia
            </p>

            <h4 className="text-xs font-semibold uppercase tracking-widest text-white/70 mb-4">PHONE</h4>
            <p className="text-base text-white/85 mb-8">+1 3639991529</p>

            <h4 className="text-xs font-semibold uppercase tracking-widest text-white/70 mb-4">EMAIL</h4>
            <a href="mailto:info@buba-doo.com" className="text-base text-white/85 hover:text-white transition-colors cursor-pointer">
              info@buba-doo.com
            </a>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-white/70 mb-4">QUICK LINKS</h4>
            <nav className="space-y-3">
              <button
                onClick={() => scrollToSection('home')}
                className="block text-base text-white/85 hover:text-white transition-colors cursor-pointer"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="block text-base text-white/85 hover:text-white transition-colors cursor-pointer"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('products')}
                className="block text-base text-white/85 hover:text-white transition-colors cursor-pointer"
              >
                Products
              </button>
              <button
                onClick={() => scrollToSection('features')}
                className="block text-base text-white/85 hover:text-white transition-colors cursor-pointer"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="block text-base text-white/85 hover:text-white transition-colors cursor-pointer"
              >
                Contact
              </button>
            </nav>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/50">
              © 2025 BUBA d.o.o. All rights reserved
            </p>
            <div className="flex items-center gap-8">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-white/50 hover:text-white/70 transition-colors cursor-pointer whitespace-nowrap">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
